import { Flex } from '@osmosis/react-ui/components/Box';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconButton } from '@osmosis/react-ui/components/IconButton';
import React from 'react';
import { P } from '@osmosis/react-ui/components/Text';
import { FormattedMessage, useIntl } from 'react-intl';
import { faThumbsDown } from '@fortawesome/pro-regular-svg-icons/faThumbsDown';
import { faThumbsUp } from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import { useQuizContext } from '../../context/QuizContext';

/**
 * Rate a question.
 */
const RateQuestion = () => {
  const { handleRateQuestion, currentResponseItem } = useQuizContext();
  const { formatMessage } = useIntl();
  const rating = currentResponseItem?.rating;

  return (
    <Flex sx={{ gap: 2 }} alignItems="center">
      <P fontSize={14} color="gray60">
        <FormattedMessage
          defaultMessage="Rate question:"
          id="quiz.rate-question"
        />
      </P>
      <IconButton
        onClick={() => handleRateQuestion(1)}
        data-testid="rate-question-positive-btn"
        aria-label={formatMessage({
          id: 'quiz.rate-question.positive',
          defaultMessage: 'Rate question positively',
        })}
        aria-pressed={rating === 1}
        variant="transparent"
        fontSize={16}
        color={rating === 1 ? 'positive' : 'gray30'}
        icon={<Icon icon={faThumbsUp} />}
      />

      <IconButton
        onClick={() => handleRateQuestion(-1)}
        data-testid="rate-question-negative-btn"
        aria-label={formatMessage({
          id: 'quiz.rate-question.negative',
          defaultMessage: 'Rate question negatively',
        })}
        aria-pressed={rating === -1}
        variant="transparent"
        fontSize={16}
        color={rating === -1 ? 'negative' : 'gray30'}
        icon={<Icon icon={faThumbsDown} />}
      />
    </Flex>
  );
};

export default RateQuestion;
